import Cronograma from '../../../components/ui/Auditor/CronogramaComponents/Cronograma';

const CronogramaUI = () => {
  return (
    <div className=" bg-gray-100">
        <Cronograma />
    </div>
  );
};

export default CronogramaUI;